export type LegalDocument = 'privacy' | 'terms' | 'impressum';

const LANGUAGE_STORAGE_KEY = 'connectandgo_language';

export const getLocalizedLegalPath = (document: LegalDocument, language?: string): string => {
  if (typeof window === 'undefined') {
    return `/${document}.html`;
  }

  try {
    const hostname = window.location.hostname.toLowerCase();
    const storedLanguage = (localStorage.getItem(LANGUAGE_STORAGE_KEY) || '').toLowerCase();
    const normalizedLanguage = (language || storedLanguage || '').toLowerCase();
    const useGerman = hostname.endsWith('.de') || normalizedLanguage === 'de';

    return useGerman ? `/${document}-de.html` : `/${document}.html`;
  } catch {
    return `/${document}.html`;
  }
};
